import { createSlice } from "@reduxjs/toolkit";

const deleteIssueSlice = createSlice({
  name: "deleteIssueData",
  initialState: [],
  reducers: {
    setDeleteIssueData: (_state, action) => action.payload,
  },
});

export const { setDeleteIssueData } = deleteIssueSlice.actions;

export const deleteIssueData = deleteIssueSlice.reducer;
